import { graphql, useStaticQuery } from 'gatsby';

import { useFlatten } from './use-flatten';
import { getProperty } from 'utils';

export const useStaticFooter = ({ menu } = {}) => {
	const results = useStaticQuery(query) || {};
	const key = 'squidex.findFooterSingleton';

	return useFlatten(getProperty(results, key) || {});
};

const query = graphql`
	query useFooterQuery {
		squidex {
			findFooterSingleton {
				id
				data {
					backgroundImage {
						iv {
							localFile {
								childImageSharp {
									gatsbyImageData(layout: FULL_WIDTH, quality: 100)
								}
							}
							...SquidexLocalFileProps
						}
					}

					hours {
						de {
							title
							text
						}
					}

					contact {
						de {
							title
						}
					}
				}
			}
		}
	}
`;
